import React from 'react'
import OurCultureSection from "../components/OurCultureSection"
import TeamSection from '../components/TeamSection'
import TeamGrid from '../components/TeamGrid'
import Partners from '../components/Partners'

const goals = [
        {
          image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744980313/image_n8gcnj.png',
          title: 'Food security',
          description: 'End hunger, achieve food security, improved nutrition and promote sustainable agriculture',
        },
        {
          image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744980313/image_19_kxewkk.png',
          title: 'Gender Equality',
          description: 'Achieve gender equality and empower all women and girls',
        },
        {
          image: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744980313/image-1_fpxqyf.png',
          title: 'Jobs',
          description: 'Promote sustained, inclusive and sustainable economic growth, full and productive employment and decent work',
        },
      ];
      const sdgGoals = [
        {
          icon: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744984704/image_dpwkgu.png',
          text: 'End hunger, achieve food security and improved nutrition and promote sustainable agriculture',
        },
        {
          icon: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744984703/image_1642_jtqpc3.png',
          text: 'Achieve gender equality and empower all women and girls',
        },
        {
          icon: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744984704/image-1_vootwy.png',
          text: 'Promote sustained, inclusive and sustainable economic growth, full and productive employment and decent work for all',
        },
        {
          icon: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744984704/image-2_rwjuve.png',
          text: 'Build resilient infrastructure, promote inclusive and sustainable industrialization and foster innovation',
        },
        {
          icon: 'https://res.cloudinary.com/dzngpgki4/image/upload/v1744984704/image-3_jspfjb.png',
          text: 'Ensure sustainable consumption and production patterns',
        },
      ];
      
const About = () => {
        
  return (
<div className='bg-white'>
<div className='md:pt-10 pt-5'>
        <div className='md:px-20 px-4 '>
<div className='flex justify-between items-center'> 
<h1 className='md:text-[36px] font-extrabold text-[#FDBD26]'>ORGANIZATION</h1>
<img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744287925/Expand_down_hlf9gz.png"
            alt="icon"
            className="w-6 h-6 md:w-8 md:h-8"
          />
</div>
<h1 className='md:text-[32px] font-bold md:mt-2 mt-1 text-[#FDBD26]'>ABOUT US</h1>
<p className='md:text-[40px] font-normal md:mt-3 mt-2'>
FarmNet is a mobile app that helps farmers manage their operations more efficiently by digitizing records, providing real-time data insights, and connecting them with service providers to boost productivity and market access.

</p>
        </div>
        <div className='md:px-20 px-4 '>
<h1 className='md:text-[32px] font-bold md:mt-8 text-[#FDBD26]'>OUR CULTURE</h1>
<OurCultureSection/>
        </div>
        <div className='md:mt-6'>
        <div className="bg-[#152C24] text-white px-6 md:py-10 py-5 md:px-20 space-y-6">
      {/* Header Section */}
      <div className="">
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744979529/image_17_o7uhnb.png"
          alt="Handshake Icon"
          className="w-20 h-20 mt-1"
        />
        <div>
          <h2 className="font-bold text-white md:mt-3 text-base md:text-[36px]">
            Partnership & Local Ownership
          </h2>
          <p className="text-sm md:text-[24px] text-white md:mt-5 leading-relaxed" style={{lineHeight:"1.30"}}>
            We work with farmers, governments, NGOs, and private sector players—not over them. We believe
            in building local capacity, hiring locally, and co-creating solutions with people on the ground.
          </p>
          <p className="italic text-sm md:text-[24px] text-white mt-4 md:mt-8">
            “Built with the people it serves.”
          </p>
        </div>
      </div>

      {/* Culture Section */}
      <div>
        <p className="font-bold text-white text-base md:mt-16 md:text-[32px]">Our Culture in 5 Words:</p>
        <p className="text-[#FFB800] font-bold md:mt-8 mt-4  text-[10px] md:text-[32px]">
          <span className="text-[#FFB800]">Empathy.</span>{' '}
          <span className="text-[#FFB800]">Inclusion.</span>{' '}
          <span className="text-[#FFB800]">Trust.</span>{' '}
          <span className="text-[#FFB800]">Innovation.</span>{' '}
          <span className="text-[#FFB800]">Community.</span>
        </p>
      </div>
      <div className='md:h-5 h-2'></div>
    </div>
        </div>
        <div className="bg-white px-4 sm:px-6 md:px-20 py-8 sm:py-10">
  {/* Header */}
  <div className="flex justify-between items-start md:items-center md:flex-row">
    <div>
      <h2 className="text-[#FDBD26] text-[16px] sm:text-[32px] font-bold">GOALS</h2>
      <p className="text-black text-[10px] sm:text-[32px] font-extrabold -mt-1">
        Allignment with UN strategic development goals
      </p>
    </div>
    <img
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744980324/image_18_hhxkjg.png"
      alt="UN Goals Logo"
      className="w-10 sm:w-28 md:w-16 md:mt-0"
    />
  </div>

  {/* Goals Grid */}
  <div className="grid grid-cols-3 md:grid-cols-3 md:gap-3 gap-1 md:mt-1 ">
    {goals.map((goal, index) => (
      <div
        key={index}
        className="relative w-full md:w-[415px] h-[100px] sm:h-[250px] bg-black rounded overflow-hidden"
      >
        <img
          src={goal.image}
          alt={goal.title}
          className="w-full h-full object-cover"
        />

        {/* Overlay */}
        <div className="absolute inset-0 bg-black bg-opacity-30" />

        {/* UN logo in top-right */}
        <div className="absolute top-3 right-3 flex flex-col items-center">
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744980484/image_1700_1_xpd5n1.png"
            alt="UN Logo"
            className="w-[12px] h-[12px] sm:w-[21px] sm:h-[22px]"
          />
          <span className="text-[5px] sm:text-[10px] text-white font-bold">UN</span>
        </div>

        {/* Conditional top-left number */}
        {(index === 0 || index === 2) && (
          <div className="absolute left-3 top-1">
            <h1 className="text-[10px] sm:text-[24px] font-bold text-white">
              {index === 0 ? '2' : '8'}
            </h1>
          </div>
        )}

        {/* Text Content */}
        <div className="absolute bottom-4 left-4 right-4 text-white">
          <h3 className="text-[10px] sm:text-[20px] md:text-[24px] font-bold leading-tight">
            {goal.title}
          </h3>
          <p className="text-[5px] sm:text-[14px] mt-1">{goal.description}</p>
        </div>
      </div>
    ))}
  </div>
</div>

  <div className="bg-white px-6 md:px-20 py-10 space-y-6">
      {sdgGoals.map((goal, index) => (
        <div key={index} className="flex items-start space-x-4">
          <img
            src={goal.icon}
            alt={`Goal ${index + 1}`}
            className="w-[50px] h-[50px] md:w-[129px] md:h-[129px]"
          />
          <p className="text-[14px] md:text-[38px] text-black font-medium leading-snug">
            {goal.text}
          </p>
        </div>
      ))}
    </div>
      <div className='md:px-20 px-4'>
<h1 className='md:text-[32px] font-bold md:mt-8 text-[#FDBD26]'>MESSAGE FROM THE CEO</h1>

      <TeamSection/>
<h1 className='md:text-[32px] font-bold md:mt-10 text-[#FDBD26]'>BOARD OF ADVISORS</h1>

        <TeamGrid/>
        <Partners/>
      </div>
    </div>
</div>
  )
}

export default About